// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".kq2RNECyJ92lSB3KjSdh i {\n  color: var(--text-neutral-white-fixed);\n}\n", "",{"version":3,"sources":["webpack://./src/templates/code-workspace.module.css"],"names":[],"mappings":"AAAA;EACE,sCAAsC;AACxC","sourcesContent":[".projectIcon i {\n  color: var(--text-neutral-white-fixed);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"projectIcon": "kq2RNECyJ92lSB3KjSdh"
};
export default ___CSS_LOADER_EXPORT___;
